import styles from './DiagramBlock.module.css';

type DiagramType = 'medallion' | 'agentic';

interface DiagramBlockProps {
  type?: DiagramType;
}

function MedallionDiagram() {
  return (
    <div className={styles.medallion}>
      <div className={styles.medallionLayer}>
        <span className={`${styles.layerTag} ${styles.tagGold}`}>Gold</span>
        <div className={`${styles.layerBar} ${styles.barGold}`}>
          <div className={styles.chips}>
            <span className={styles.chip}>Analytics</span>
            <span className={styles.chip}>Reporting</span>
            <span className={styles.chip}>ML Features</span>
            <span className={styles.chip}>Agentic AI</span>
          </div>
        </div>
      </div>
      <div className={styles.medallionLayer}>
        <span className={`${styles.layerTag} ${styles.tagSilver}`}>Silver</span>
        <div className={`${styles.layerBar} ${styles.barSilver}`}>
          <div className={styles.chips}>
            <span className={styles.chip}>Validation</span>
            <span className={styles.chip}>Enrichment</span>
            <span className={styles.chip}>Governance</span>
          </div>
        </div>
      </div>
      <div className={styles.medallionLayer}>
        <span className={`${styles.layerTag} ${styles.tagBronze}`}>Bronze</span>
        <div className={`${styles.layerBar} ${styles.barBronze}`}>
          <div className={styles.chips}>
            <span className={styles.chip}>Raw Ingest</span>
            <span className={styles.chip}>CDC</span>
            <span className={styles.chip}>Streaming</span>
            <span className={styles.chip}>Batch</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function AgenticDiagram() {
  const agents = [
    { icon: '🔍', label: 'Discovery Agent', role: 'Data catalog & lineage' },
    { icon: '⚙️', label: 'Pipeline Agent', role: 'Orchestration & ETL' },
    { icon: '🛡️', label: 'Governance Agent', role: 'Quality & compliance' },
    { icon: '📊', label: 'Analytics Agent', role: 'Insight generation' },
    { icon: '🤖', label: 'ML Agent', role: 'Model lifecycle' },
    { icon: '🔔', label: 'Alert Agent', role: 'Monitoring & SLAs' },
  ];
  return (
    <div className={styles.agentic}>
      {agents.map((a) => (
        <div key={a.label} className={styles.agentNode}>
          <div className={styles.agentIcon}>{a.icon}</div>
          <div className={styles.agentLabel}>{a.label}</div>
          <div className={styles.agentRole}>{a.role}</div>
        </div>
      ))}
    </div>
  );
}

export function DiagramBlock({ type = 'medallion' }: DiagramBlockProps) {
  return (
    <div className={styles.block}>
      <div className={styles.title}>
        {type === 'medallion' ? 'Medallion Architecture' : 'Agentic AI System'}
      </div>
      {type === 'medallion' ? <MedallionDiagram /> : <AgenticDiagram />}
    </div>
  );
}
